<template>
    <v-card min-width="37vw" class="d-flex align-center justify-center" style="z-index: 10!important;" outlined>
        <div style="width: 100% !important;">
            <v-card-title class="text-center py-1">
                <v-list-item>
                    <v-list-item-title><h3>{{ title }} | {{ $t('title') }}</h3></v-list-item-title>
                    <v-spacer/>
                    <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
                </v-list-item>
            </v-card-title>
            <v-card-text class="pa-0" >
                <v-container class="py-0" fluid>
                    <v-row>
                        <iframe width="100%" height="329" :src="`https://www.youtube.com/embed/${videoUrl}`"
                                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </v-row>
                </v-container>
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
    export default {
        name: "EducationalVideo",
        props: {
            title: String,
            videoUrl: String,
        },
        data() {
            return {

            };
        },
        methods: {
            closeWindow() {
                this.$emit('closeWindow');
            },
        },
    }
</script>



<style scoped>

</style>
